import React from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useTranslation } from '@refinedev/core';
import { endPoints } from '@/api/configs';
import useAPI from '@/api/useApi';

interface AddDomainModalProps {
  open: boolean;
  onCancel: () => void;
  refetch: () => void;
}

export const AddDomainModal: React.FC<AddDomainModalProps> = ({
  open,
  onCancel,
  refetch,
}) => {
  const { translate } = useTranslation();
  const [form] = Form.useForm();
  const { usePatch } = useAPI();
  const { mutate: createDomain, isLoading } = usePatch(endPoints.systemConfig);
  const handleOk = async () => {
    const values = await form.validateFields();
    if (values) {
      createDomain(
        {
          operation: 'ADD',
          field: 'WHITELISTED_DOMAIN',
          value: form.getFieldValue('domain'),
        },
        {
          onSuccess: () => {
            message.success(translate('system-config.domains.added'));
            form.resetFields();
            onCancel();
            refetch();
          },
          onError: (error) => {
            message.error(error.message);
          },
        }
      );
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={translate('system-config.domains.addDomain')}
      open={open}
      onOk={handleOk}
      okText={translate('system-config.domains.addDomain')}
      onCancel={handleCancel}
      cancelText={translate('system-config.domains.cancel')}
      okButtonProps={{ loading: isLoading }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="domain"
          label={translate('system-config.domains.name')}
          rules={[
            {
              required: true,
              message: translate('pages.errors.required'),
            },
            {
              pattern: /^[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
              message: translate('pages.errors.invalidDomain'),
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
